module.exports = "https://static.wmbcdn.com/uniweb/images/96e876c60945a97973bf463d4110e37f.svg";